(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
   document.addEventListener("DOMContentLoaded", function() {

        const swiperEl = document.querySelector('.autoscroll-swiper');
        const spaceBetween = parseInt(swiperEl.dataset.spaceBetween, 10);

        const swiper = new Swiper('.autoscroll-swiper', {
    slidesPerView: 'auto',
    spaceBetween: spaceBetween,
    loop: true,
    speed: 15000,
    freeMode: true,
    freeModeMomentum: false,
    autoplay: {
        delay: 0,
        disableOnInteraction: false,
        reverseDirection: true
    },
    allowTouchMove: false,
    breakpoints: {
        767: {
            slidesPerView: 'auto',
            freeMode: true,
            freeModeMomentum: false,
            allowTouchMove: false,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
                reverseDirection: true
            }
        }
    },
    on: {
        init: function() {
            const swiperEl = this.el;
            
            swiperEl.addEventListener('mouseenter', () => {
                console.log('Pausing');
                this.autoplay.stop();
                // Force stop the transition
                this.setTransition(0);
            });
            
            swiperEl.addEventListener('mouseleave', () => {
                console.log('Resuming');
                this.autoplay.start();
                this.setTransition(this.params.speed);
            });
        }
    }
});

    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logos-slider"] && !Shopify.designMode) return;
  try {
    
   document.addEventListener("DOMContentLoaded", function() {

        const swiperEl = document.querySelector('.logo-swiper');
        const spaceBetween = parseInt(swiperEl.dataset.spaceBetween, 10);

        const swiper = new Swiper('.logo-swiper', {
            slidesPerView: 3,
            spaceBetween: spaceBetween,
            loop: true,
            speed: 5000,
            freeMode: true,
            freeModeMomentum: false,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
            },
            allowTouchMove: false,

            // 👇 Add breakpoints
            breakpoints: {
                767: {
                    slidesPerView: 6
                }
            }
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-navigation"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {

    const mobileToggle = document.querySelector(".js--mobile-toggle");
    const mobileClose = document.querySelector(".js--mobile-close");
    const mobileNav = document.querySelector(".js--navigation-mobile");
    const stickyNav = document.querySelector(".js--navigation-sticky");

    // Mobile toggler
    if (mobileToggle) {
      mobileToggle.addEventListener("click", () => {
        mobileNav.classList.toggle("active");
        mobileToggle.classList.toggle("active");
      });

      mobileClose.addEventListener("click", () => {
        mobileNav.classList.remove("active");
      })
      
      
    }


    // Sticky behavior
    if (stickyNav) {
      window.addEventListener("scroll", () => {
        if (window.scrollY > 150) {
          stickyNav.classList.add("visible");
        } else {
          stickyNav.classList.remove("visible");
        }
      });
    }

  });

  } catch(e) { console.error(e); }
})();
})();
